import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import Env from '../../../../util/env';
import {labels} from '../../../../util/utils';
import {projectStatusEnum, serviceURL} from '../../../../util/uiconstants';

import {markCompleteProject} from '../../../../actions/Project/projectAction';

import ProjectConfirmationModal from '../ProjectConfirmationModal';

const MarkAsCompleteModal = ({show, setShow, projectId, name}) => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const onHide = () => setShow(false);

	const onConfirm = () => {
		const projectApiUrl = `${Env.getBaseURL(serviceURL)}Projects/${projectId}`;
		const payload = {
			id: projectId,
			body: {status: projectStatusEnum.COMPLETED}
		};
		setIsLoading(true);
		dispatch(markCompleteProject(projectApiUrl, payload))
			.then(() => {
				setIsLoading(false);
				onHide();
			})
			.catch(() => setIsLoading(false));
	};

	const props = {
		show,
		onHide,
		onConfirm,
		isLoading,
		title: labels.markAsCompleted,
		confirmLabel: labels.confirm,
		instructional: `${labels.markCompleteModalInstrTextPart1}<br>${labels.markCompleteModalInstrTextPart2}`,
		projectName: name || ''
	};

	return <ProjectConfirmationModal {...props} />;
};

MarkAsCompleteModal.propTypes = {};

MarkAsCompleteModal.defaultProps = {};

export default MarkAsCompleteModal;
